/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Integration undeployment request
 * @export
 * @interface IntegrationUndeploymentRequest
 */
export interface IntegrationUndeploymentRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationUndeploymentRequest
     */
    instanceId?: string;
}

/**
 * Check if a given object implements the IntegrationUndeploymentRequest interface.
 */
export function instanceOfIntegrationUndeploymentRequest(value: object): value is IntegrationUndeploymentRequest {
    return true;
}

export function IntegrationUndeploymentRequestFromJSON(json: any): IntegrationUndeploymentRequest {
    return IntegrationUndeploymentRequestFromJSONTyped(json, false);
}

export function IntegrationUndeploymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationUndeploymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
    };
}

export function IntegrationUndeploymentRequestToJSON(json: any): IntegrationUndeploymentRequest {
    return IntegrationUndeploymentRequestToJSONTyped(json, false);
}

export function IntegrationUndeploymentRequestToJSONTyped(value?: IntegrationUndeploymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instanceId': value['instanceId'],
    };
}

